export class  UiRuleReqPayload {
    component: ComponentAttributes;    

    constructor(comp: ComponentAttributes){
        this.component = comp;
    }
}

export class ComponentAttributes {
    /*
    screen: string;
    panel: string;
    attribute: AttributeReqPayLoad[];
*/
    constructor(public component: string, public attribute: AttributeReqPayLoad[],
        public fundDetails?: FundDetailReqPayLoad[]) {
     //   this.screen = screenName;
      //  this.panel = panelName;
       // this.attribute = attributeList;
    }
}

export class  AttributeReqPayLoad {
    attributeName: string;
    attributeValue: any;

    constructor(name: string, value: any){
        this.attributeName = name;
        this.attributeValue = value;
    }
}

export class  AttributeArrayReqPayLoad {
    attributeName: string;
    attributeListValue: any;

    constructor(name: string, value: any){
        this.attributeName = name;
        this.attributeListValue = value;
    }
}

export class  FundDetailReqPayLoad {
   

    constructor(public cedingProvider: string, public productCode: string, public cedPen_policyNo: string,
        public transferType: string, public amountType: string, public pensionFund: string, public taxFreeCashPercentage: string,
        public taxFreeCashAmount: string, public selectedInd: boolean,public oldProductCode:string ='',public nrdRetirementDate:string =''
        ,public planStartDate:string ='',public dateRevaluedTo:string ='',public valuationExpiryDate:string =''
        ,public execessQuoteAllowed:string ='',public genderSpecificRate:string ='') {
    }
}